import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { withRouter } from 'react-router';
import { PHOTO_PLACEHOLDER } from '../../constants/images';
import { PAGE_ROUTES } from '../../constants/pageRoutes';

class RelevantPosts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetching: false,
      relevantPosts: []
    }

    this.hasTags = this.hasTags.bind(this);
    this.fetchRelevantPosts = this.fetchRelevantPosts.bind(this);
    this.getFeaturedMedia = this.getFeaturedMedia.bind(this);
  }

  hasTags = () => {
    const { tags } = this.props;
    return !!tags && tags.length;
  }

  fetchRelevantPosts = () => {

    if (!this.hasTags())
      return;

    this.setState({
      ...this.state,
      isFetching: true
    })

    const query = `?tags=${this.props.tags.join(',')}&per_page=3&_embed`;
    fetch(`/wp-json/wp/v2/posts${query}`)
      .then(response => response.json())
      .then(json => {
        this.setState({
          ...this.state,
          relevantPosts: json,
          isFetching: false
        })
      })
  }

  getFeaturedMedia = (post) => {
    const images = post._embedded["wp:featuredmedia"]
    return !!images && images.length ? images[0].media_details.sizes.medium.source_url : PHOTO_PLACEHOLDER
  }

  componentDidMount = () => {
    this.fetchRelevantPosts();
  }

  render() {

    if (!this.hasTags || (this.state.isFetching) || (!this.state.relevantPosts.length))
      return null;

    return (
      <div className="featured-blog-post-section">
        <div className="blog-post-container">
          <div className="post-detail">
            <div className="detail-left">
              <h2 className="title-post">Related Blog Posts</h2>
              <p className="pg-post">Great resources for renters and owners: tips to help plan your trip,
                explore new college towns as well as tips for owners to showcase your listing.</p>
            </div>
            <div className="detail-right">
              <a href={`${PAGE_ROUTES.BLOGS_AND_RESOURCES}/#/`} type="button" className="btn secondary">Find More</a>
            </div>
          </div>
          <div className="post-card-section">
            <div className="card-container">
              {
                this.state.relevantPosts.map((post, key) => {
                  return (
                    <a href={post.link} key={post.id}>
                      <div className="post-box">
                        <div className="post-image-box">
                          <img src={this.getFeaturedMedia(post)} className="card-post-image" alt-="post" />
                        </div>
                        <div className="recent-post-detail">
                          <h3 className="title-card">{ReactHtmlParser(post.title.rendered)}</h3>
                          <div className="card-pg">{ReactHtmlParser(post.excerpt.rendered)}</div>
                        </div>
                      </div>
                    </a>
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(RelevantPosts);
